import SchoolProfileCard from './SchoolProfileCard.component';

export default SchoolProfileCard;